// import { findByProjectsId } from "@/services/custom";
// import { getOrigin } from "@/utils";
// import { createURL } from "@/utils/common";
import { useRef, useState } from "react";
import {SActionBtn, SCommonTable, SFuncModal, SLowcodeList, STableActions} from "shj-components";
import {findByProjectsId} from "@/services/kuAccount.ts";
import {getOrigin} from "@/utils";
import {createURL} from "@/utils/common.ts";
import {baseURL} from "@/api";

export function historyVersionFn({ fn, ...rest }: { id?: any, fn?: () => void, }) {
    const destroy = () => {
        dialog.destroy();
    };
    const dialog: any = SFuncModal({
        title: `历史版本`,
        width: 800,
        vanish: true,
        content: <DioSubmitModelDom2 fn={fn} onClose={destroy} {...rest} />,
    });
}
const DioSubmitModelDom2: React.FC<any> = ({ fn, onClose, ...rest }: { fn: () => void, onClose: () => void, data?: any }) => {
    const addRef = useRef(null);
    const [loading, setLoading] = useState(false);
    return <SFuncModal.Content
        footer={null}
        confirmLoading={loading}
    >
        <HistoryTab onClose={onClose} fn={fn} ref={addRef}   {...rest} />
    </SFuncModal.Content>
}
export const HistoryTab = (props: any) => {
    const { id, trackParams } = props;
    const tableRef = useRef<any>();
    const historyColumns: any[] = [
        {
            title: '方案ID',
            dataIndex: 'projectsId',
            width: 120,
        },
        {
            title: '案例ID',
            dataIndex: 'casesId',
            width: 120,
        },
        {
            title: '方案名',
            dataIndex: 'name',
            width: 200,
        },
        {
            title: '版本号',
            dataIndex: 'versionNumber',
            width: 100,
        },
        {
            title: '版本描述',
            dataIndex: 'description',
            width: 200,
        },
        {
            title: '标签',
            dataIndex: 'versionType',
            width: 200,
        },
        {
            title: '创建人',
            dataIndex: 'createdBy',
            width: 200,
        },
        {
            title: '发版时间',
            dataIndex: 'publishVerTime',
            itemType: 'dateTime',
            width: 160,
        },
        {
            title: '操作',
            dataIndex: '#',
            width: 100,
            fixed: 'right',
            render: (text: any, record: any) => {
                return <STableActions>
                    <SActionBtn
                        primary
                        onClick={() => {
                            const url = createURL(`design/#/preview/done/${record.id}`, trackParams)
                            window.open(baseURL.replace('/api', '') + url);
                        }}
                    >
                        方案预览
                    </SActionBtn>
                </STableActions>
            },
        },
    ];

    const fetchList = async () => {
        return new Promise(async (resolve, reject) => {
            try {
                findByProjectsId({
                    data: {
                        projectsId: id, //案例  1318  theCaseId
                    }
                }).then((resp: any) => {
                    const _records = resp;
                    resolve({ records: [..._records], total: _records.length } );
                });
            } catch (e) {
                reject({ success: false });
            }
        });
    };

    const extension = {
        request: {fetchList}
    }

    return (
        <>
            <SLowcodeList
                config={{columns: historyColumns, fieldControl: false, rowSelection: false}}
                searchMode={'group'}
                {...extension}
                ref={tableRef}
            />
        </>
    );
};
